export const textBoldCSS = { fontWeight: 'bold' } as const
